/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../_helpers";

export function TilesWidget11({
  className,
  count,
  title,
  baseColor = "primary",
  widgetHeight = "150px",
  widgetWidth = "150px",
}) {
  return (
    <>
      <div
        className={`card card-custom bg-${baseColor} ${className}`}
        style={{ height: widgetHeight, width:widgetWidth }}
      >
        <div className="card-body pt-5">
          <div className={`text-inverse-${baseColor} font-weight-bolder font-size-h2 mt-3`}>
            {count || 0}
          </div>
          <div className={`text-inverse-${baseColor} font-weight-bold font-size-lg mt-1`}>
            {title}
          </div>
        </div>
      </div>
    </>
  );
}
